import TweenMax from 'gsap/TweenMax';

export default function SlideDown(
  container,
  canvas,
  duration,
  beforeAnimation
) {
  const {
    top: containerTop,
    right: containerRight,
    width: containerWidth,
  } = container.getBoundingClientRect();

  const { top: canvasTop, left: canvasLeft } = canvas.getBoundingClientRect();
  const initialX = canvasLeft - containerRight + containerWidth / 2;
  const initialY = containerTop - canvasTop + 90;

  beforeAnimation(initialX, initialY);

  TweenMax.to(container, 0.25, {
    opacity: 1,
  });
}
